export const messages = {
    methodOrPropertyNotExists: (moduleName, platformName, name) => `Method or propety '${name}' not exist in a module ${moduleName} of POS-Platform '${platformName}'.`,
    unknownPlatform: (platformName) => `Unknown POS-Platform '${platformName}'.`,
    moduleNotFound: (moduleName) => `Module '${moduleName}' was not found. Please, try register it before`,
    definePlatform: `Please, define POS-Platform name.`,
    initNotStarted: `Initialization dit not started`,
    invalidResponse: `Invalid response`,
}
